import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import MarathonsContent from '../../../components/Pages/Marathons/Results';

const { displayName } = config;

export default function MarathonResults(): React.ReactNode | null {
  document.title = `${displayName}: Результаты`;

  return (
    <Layout>
      <MarathonsContent />
    </Layout>
  );
}
